import { collection, onSnapshot, type Unsubscribe } from 'firebase/firestore'
import { firestoreDb } from './firebase'
import type { WorkspaceRole } from '../types/workspace'

export type MembershipChangeType = 'added' | 'modified' | 'removed'

export interface MembershipChangeEvent {
  type: MembershipChangeType
  workspaceId: string
  role?: WorkspaceRole | string
  status?: string
  data?: Record<string, unknown>
  isInitial?: boolean
}

export interface SubscribeToMyMembershipsCallbacks {
  onChange: (change: MembershipChangeEvent) => void
  onError?: (error: unknown) => void
}

/**
 * Subscribes to changes in `users/{uid}/workspaceMemberships` (the membership mirror).
 * Emits added, modified (with role, status), and removed changes.
 */
export const subscribeToMyMemberships = (
  uid: string,
  callbacks: SubscribeToMyMembershipsCallbacks,
): Unsubscribe => {
  const membershipsRef = collection(firestoreDb, 'users', uid, 'workspaceMemberships')
  let isInitialSnapshot = true
  return onSnapshot(
    membershipsRef,
    (snapshot) => {
      const isInitial = isInitialSnapshot
      isInitialSnapshot = false
      snapshot.docChanges().forEach((change) => {
        const workspaceId = change.doc.id
        const data = (change.doc.data() || {}) as Record<string, unknown>
        callbacks.onChange({
          type: change.type,
          workspaceId,
          role: data.role as WorkspaceRole | string | undefined,
          status: data.status as string | undefined,
          data,
          isInitial,
        })
      })
    },
    (error) => {
      console.warn('[membershipLiveService] Live users/{uid}/workspaceMemberships listener failed:', error)
      callbacks.onError?.(error)
    },
  )
}
